module.exports = __webpack_public_path__ + "static/media/537.2202e0a4.webp";